import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Layout from "../../components/Layout"
import * as styles from "../../styles/industry.module.css"

const imageFor = (images, relativePath) =>
  images.nodes.find(image => image.relativePath === relativePath)

const Industry = ({ data }) => {
  const supconCover = imageFor(data.images, "supconIntro/cover1.jpg")
  const teckCover = imageFor(data.images, "teckIntro/cover.webp")

  return (
    <Layout>
      <article className={styles.industry}>
        <header className={styles.header}>
          <p>Industry</p>
          <h1>Industrial Project Experience</h1>
        </header>

        <div className={styles.cardGrid}>
          <Link className={styles.card} to="/industry/supcon">
            {supconCover && (
              <Img
                className={styles.cardImage}
                fluid={supconCover.childImageSharp.fluid}
                alt="SUPCON ECS-700 laboratory training"
              />
            )}
            <div className={styles.cardText}>
              <p>SUPCON Technology</p>
              <h2>DCS Laboratory Development and Industrial Training</h2>
              <span>May 2026 - Present</span>
            </div>
          </Link>

          <Link className={styles.card} to="/industry/teck">
            {teckCover && (
              <Img
                className={styles.cardImage}
                fluid={teckCover.childImageSharp.fluid}
                alt="Teck Resources industrial analytics project"
              />
            )}
            <div className={styles.cardText}>
              <p>Teck Resources Limited</p>
              <h2>Student Researcher</h2>
              <span>Feb. 2024 - Jun. 2026</span>
            </div>
          </Link>
        </div>
      </article>
    </Layout>
  )
}

export default Industry

export const query = graphql`
  query IndustryPage {
    images: allFile(
      filter: {
        sourceInstanceName: { eq: "industry" }
        extension: { in: ["jpg", "jpeg", "png", "webp"] }
      }
    ) {
      nodes {
        relativePath
        childImageSharp {
          fluid(maxWidth: 760) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`
